import * as React from 'react';
const CardExtraContext = React.createContext(null);
const CardExtraProvider = CardExtraContext.Provider;
const useCardExtraCtx = () => React.useContext(CardExtraContext);
export { CardExtraContext, CardExtraProvider, useCardExtraCtx };
